import React from 'react'
import {IconButton, Grid, Button, Typography} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import useCalendarViewContext from '../../../../../context/CalendarView'
import _ from 'lodash'

const FilterSelectValue = ({
  options,
  handleClickSelectedValueOption,
  handleCloseValueOption,
  value,
  values,
  handleApplyFilter,
  setSharableFilters,
}) => {
  const {viewData, setViewData} = useCalendarViewContext()

  const isSelected = id => {
    if (value && (value?.field_id === id || value?.id === id)) {
      return true
    }
    return false
  }

  const handleClearAllOption = () => {
    values = []
    setSharableFilters(values)
    setViewData({...viewData, selectedFilterValueFields: []})
  }

  return (
    <>
      <div className="c-res-mod ap-list ap-scrollbar apply-filter-section">
        <Grid row xs={12}>
          <Grid xs={9}>
            <Typography className="ap-typography--sm font-14 applied-filter-text">
              {' '}
              Applied Filters{' '}
            </Typography>
          </Grid>
          <Grid xs={3}>
            <Button className="clear clear-filter" onClick={e => handleClearAllOption(e)}>
              {' '}
              Clear{' '}
            </Button>
          </Grid>
        </Grid>
        <div
          className="ap-list__wrapper height-100-per overflow-auto scroll-bar-style"
          style={{padding: '15px 0px'}}
        >
          {values.map((o, i) => {
            const field = options.find(option => option.field_id === o.id)
            return (
              <>
                <div
                  key={i}
                  className={`width-98-per ap-list__item border-radius-4 ap-typography ap-typography--sm ap-flex ap-flex--start ap-flex--align-center c-pop-field-toggle__option c-pop-selected-field-toggle
                ${isSelected(o.id) ? 'selected_filter_selected_value' : ''} filter-item-list`}
                  style={{cursor: 'pointer'}}
                >
                  <Grid
                    item
                    xs={10}
                    onClick={e => handleClickSelectedValueOption(e, o)}
                    className="word-break-all"
                  >{`(${o.value.length}) ${o.field_name ? o.field_name : field?.field_name}`}</Grid>
                  <Grid item xs={2} className="text-right">
                    <IconButton
                      type="submit"
                      className=""
                      underline={false}
                      aria-label="search"
                      style={{padding: 0, color: `${isSelected(o.id) ? '#003099' : ''} `}}
                      onClick={e => handleCloseValueOption(e, o)}
                      disableRipple
                    >
                      <CloseIcon className="cancel-value-icon" />
                    </IconButton>
                  </Grid>
                </div>
              </>
            )
          })}
          <div className="apply-button-container radius-4">
            <Button
              style={{borderRadius: 4}}
              onClick={handleApplyFilter}
              className="ap-button ap-button--primary font-bold radius-4 save-btn"
            >
              Apply
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default FilterSelectValue
